import { type FC } from 'react';
import classNames from 'classnames';
import { ChildNavigationItem } from '../../../../../ReactSharedScripts/modules/toolNavigation/types';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';
import { TooltipBtn } from '../../../../../ReactSharedScripts/components/TooltipBtn';
import { ToolNavigationCollapsedLink } from './ToolNavigationCollapsedLink';
import { ToolNavigationCollapsedTooltipList } from './ToolNavigationCollapsedTooltipList';
import {
	ToolNavigationActiveLine,
} from '../../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationActiveLine';
import classes from '../styles/index.module.css';
import { SvgComponentProps } from '../../../../../ReactSharedScripts/components/Icons/types';

type ToolNavigationCollapsedItemProps = {
	title: string;
	url: string;
	isActive: boolean;
	pageTypeId: number;
	childNavigationItems: ChildNavigationItem[];
	icon: FC<SvgComponentProps>
};

export const ToolNavigationCollapsedItem: FC<ToolNavigationCollapsedItemProps> = ({
	title,
	url,
	isActive,
	icon,
	childNavigationItems,
}) => {
	const { theme } = useStyleContextState();

	const navigationItemClasses = classNames(classes.toolNavigation__collapsedItem, {
		[classes.toolNavigation__collapsedItem_active]: isActive,
	});

	return (
		<div className={navigationItemClasses}>
			{isActive && <ToolNavigationActiveLine />}
			{childNavigationItems.length > 1 ? (
				<TooltipBtn
					tooltip={
						<ToolNavigationCollapsedTooltipList
							childNavigationItems={childNavigationItems}
						/>
					}
					tooltipTheme={theme}
					tooltipPosition='right'
					tooltipAlign='end'
				>
					<ToolNavigationCollapsedLink
						isActive={isActive}
						title={title}
						icon={icon}
					/>
				</TooltipBtn>
			) : (
				<ToolNavigationCollapsedLink
					url={url}
					isActive={isActive}
					title={title}
					icon={icon}
				/>
			)}
		</div>
	);
};
